import React from 'react';
import useIsColorDark from 'hooks/useIsColorDark';
import { SectionLayout } from 'components/Sections/SectionLayout';
import ContentfulRichText from 'components/RichText/ContentfulRichText';
import getBreakpointView from 'utils/getBreakpointView';

import { StyledRow, StyledCol } from './styles';

const ContentfulRowContent = ({
  bgColor,
  backgroundCornerImage,
  backgroundImage,
  flipBackgroundImage,
  gradientDirection,
  columns,
  fullWidthContent,
  reverseMobileColumnOrder,
  anchorId,
  ...otherProps
}) => {
  const isMobile = getBreakpointView(['xs', 'sm']);

  const backgroundImageToRender =
    isMobile && backgroundImage?.imageMobile
      ? backgroundImage?.imageMobile
      : backgroundImage?.image;

  const bgImg = backgroundImageToRender?.file?.url;

  let columnSpace;
  if (fullWidthContent) {
    columnSpace = 24;
  } else if (columns?.length > 1) {
    columnSpace = 24 / columns?.length;
  } else {
    columnSpace = 14;
  }

  let reverseInMobile = reverseMobileColumnOrder;
  if (columns?.length === 2 && !reverseInMobile) {
    columns.forEach((contentItem, index) => {
      contentItem?.content?.json?.content.forEach(item => {
        const imageType = item?.data?.target?.fields?.image;

        if (imageType && index === 1) {
          reverseInMobile = true;
        }
      });
    });
  }

  return (
    <SectionLayout
      backgroundColor={bgColor}
      backgroundImageTypeWithPosition={backgroundCornerImage}
      backgroundImg={bgImg}
      contentBelowSection={otherProps?.contentBelowSection}
      gradientDirection={gradientDirection === 'None' ? null : gradientDirection}
      id={anchorId}
    >
      <StyledRow
        type="flex"
        justify="center"
        align="middle"
        gutter={80}
        $reverseInMobile={reverseInMobile}
      >
        {columns?.map((col, index) => {
          let isBackgroundDark;

          if (bgImg) {
            isBackgroundDark = true;
          } else if (bgColor === 'Azure' || bgColor === 'Sky Blue') {
            isBackgroundDark = true;
          } else if (bgColor === 'Transparent' || bgColor === 'Bright Neutral') {
            isBackgroundDark = false;
          } else {
            isBackgroundDark = useIsColorDark(bgColor);
          }

          const textColor = col?.color ? col?.color : isBackgroundDark ? 'var(--white)' : null;
          const richTextContent = {
            ...col,
            color: textColor,
            dataPosition: 'Row Content',
          };

          return (
            <StyledCol
              lg={columnSpace}
              md={columnSpace}
              sm={columnSpace}
              xs={24}
              $hideSpacer={col.anchorId === '_spacer_'}
              className={
                otherProps.pageType === 'terms' ? 'row-content-terms--col' : 'row-content--col'
              }
              key={`row-content--col-${index}`}
              $textColor={textColor}
            >
              <ContentfulRichText richText={richTextContent} dataPosition="Row Content" />
            </StyledCol>
          );
        })}
      </StyledRow>
    </SectionLayout>
  );
};

export default ContentfulRowContent;
